module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-sm-12 align-left footer-bottom"
  }, [_c('p', [_vm._v("\n    Copyleft \n    "), _c('router-link', {
    staticClass: "no-link copyleft",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("©")]), _vm._v("\n     "), _c('a', {
    attrs: {
      "href": "https://foobar.beer"
    }
  }, [_vm._v("Jakub Stonavský")]), _vm._v(" 2022 \n    All rights "), _c('a', {
    attrs: {
      "href": "http://wtfpl.net",
      "title": "WTFPL"
    }
  }, [_vm._v("ignored")]), _vm._v(".\n    "), _c('api-check')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02131b2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FooterCopyleft.vue
// module id = 1819
// module chunks = 1